// Captura `beforeinstallprompt` global y lo expone para que cualquier
// componente pueda lanzarlo. El listener debe registrarse antes de que Vue
// monte ningún componente; si no, perdemos el evento (se dispara muy temprano
// al cargar la PWA).

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

let deferred: BeforeInstallPromptEvent | null = null
let installed = false
const listeners: Array<(ready: boolean) => void> = []

function notify() {
  for (const l of listeners) l(Boolean(deferred))
}

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    deferred = e as BeforeInstallPromptEvent
    notify()
  })
  window.addEventListener('appinstalled', () => {
    deferred = null
    installed = true
    notify()
  })
}

export function isInstallable(): boolean {
  return Boolean(deferred)
}

export function isInstalled(): boolean {
  if (installed) return true
  if (typeof window === 'undefined') return false
  if (window.matchMedia('(display-mode: standalone)').matches) return true
  return Boolean((window.navigator as { standalone?: boolean }).standalone)
}

export async function triggerInstall(): Promise<'accepted' | 'dismissed' | 'unavailable'> {
  if (!deferred) return 'unavailable'
  await deferred.prompt()
  const choice = await deferred.userChoice
  deferred = null
  notify()
  return choice.outcome
}

export function onInstallReady(cb: (ready: boolean) => void): () => void {
  listeners.push(cb)
  // Notificar estado actual inmediatamente
  cb(Boolean(deferred))
  return () => {
    const idx = listeners.indexOf(cb)
    if (idx >= 0) listeners.splice(idx, 1)
  }
}
